import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value`. The returned value only updates
 * after `delayMs` have passed without `value` changing — useful for
 * wiring text inputs to network queries without firing on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
